export const ROUTES={
    root:'/',
    login:'/login',
    control:'/controle',
    afterLogin:'/controle/caixa',
    
}